import {
   URL_SAVE_CRITERIA,
   URL_SAVE_CRITERIA_FILTER_OF_USER_ID,
   URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID,
   URL_CORE_PRICING_DISTRIBUTION_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID,
   URL_CORE_PRICING_FOOTNOTES_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID,
   URL_CORE_PRICING_RULES_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID,
} from '../end-points.js';

const URL_SAVED_CRITERIA_SEARCH_USER_ID = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'`;
const URL_SAVED_CRITERIA_SEARCH_USER_ID_DISTRIBUTION_SCREEN = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_DISTRIBUTION_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'`;
const URL_SAVED_CRITERIA_SEARCH_USER_ID_FOOTNOTES_SCREEN = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_FOOTNOTES_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'`;
const URL_SAVED_CRITERIA_SEARCH_USER_ID_RULES_SCREEN = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_RULES_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'`;

export const getStoredCriteriaUrl = (screenName, userId) => {
   switch (screenName) {
      case 'Fares':
         return `${URL_SAVED_CRITERIA_SEARCH_USER_ID}${userId}'`;
      case 'Reference':
         return `${URL_SAVED_CRITERIA_SEARCH_USER_ID_DISTRIBUTION_SCREEN}${userId}'`;
      case 'Footnotes':
         return `${URL_SAVED_CRITERIA_SEARCH_USER_ID_FOOTNOTES_SCREEN}${userId}'`;
      case 'Rules':
         return `${URL_SAVED_CRITERIA_SEARCH_USER_ID_RULES_SCREEN}${userId}'`;
      default:
         return '';
   }
};
